import { useAppDispatch } from 'reduxTyped'
import { AiAutomationAnalytics } from 'apps/aiAutomation/lib/analytics'
import { SidebarViewType } from 'apps/aiAutomation/lib/sidebar'
import { AiAutomationLayoutActions } from 'apps/aiAutomation/store/layout'
import { KnowledgeEntry, KnowledgeEntryType } from 'shared/api/requests/aiBusinessKnowledge/schemas'

export type NewEntrySource = Parameters<
  typeof AiAutomationAnalytics.logKnowledgeEditorOpened
>[0]['source']

export const useOpenKnowledgeEditor = () => {
  const dispatch = useAppDispatch()

  const openNew = (entryType: KnowledgeEntryType, source: NewEntrySource) => {
    dispatch(
      AiAutomationLayoutActions.sidebarOpened({
        view: SidebarViewType.KNOWLEDGE_EDITOR,
        payload: {
          newEntryType: entryType,
        },
      }),
    )

    AiAutomationAnalytics.logKnowledgeEditorOpened({
      entry_state: 'new',
      source,
      entry_type: entryType,
    })
  }

  const openExisting = (entry: Pick<KnowledgeEntry, 'id' | 'type'>, editMode?: boolean) => {
    dispatch(
      AiAutomationLayoutActions.sidebarOpened({
        view: SidebarViewType.KNOWLEDGE_EDITOR,
        payload: {
          entryId: entry.id,
          editMode,
        },
      }),
    )

    AiAutomationAnalytics.logKnowledgeEditorOpened({
      entry_state: 'existing',
      source: 'training',
      entry_id: entry.id,
      entry_type: entry.type,
    })
  }

  return { openNew, openExisting }
}
